import React, { useEffect, useState } from 'react';
import "./NewLayout.css";
import WrongAddress from './CommonPages/WrongAddress';
import UserProfile from "./Context/UserProfile";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage  from "./HomePage/HomePage";
import LandingPage  from "./LandingPage/LandingPage";
import UpdateUser from './LandingPage/UpdateUser';
import LogOut from './LandingPage/LogOut';
import DetailContract from './DetailPO/DetailContract';

import TermsAndCondtitions from './LandingPage/TermsAndConditions';
import PrivacyPolicy from './LandingPage/PrivacyPolicy';
import AboutUs from './LandingPage/AboutUs';
import { checkConnection } from './Services/ContrectBackendAPI';
import UnderMaintenance from './CommonPages/UnderMaintenance';
import DraftInvoice from "./NewPO/DraftInvoice";
import EditInvoice from './NewPO/EditInvoice';
import EditTxnNote from "./NewPO/EditTxnNote";

import AIGenerateContract from "./D2CTemplates/AIGenerateContract";

import DraftContract from "./D2CTemplates/DraftContract";
import PaymentComponent from './SubscriptionsAndPayments/PaymentComponent';
import SubscriptionPage from './LandingPage/SubscriptionPage';
import SignInPage from './LandingPage/SignInPage';
import FormButton from './FormParts/FormButton';
import ContractListPage from "./HomePage/ContractListPage";

import AnalyticsPage from "./HomePage/AnalyticsPage";
import ContactUs from './LandingPage/ContactUs';
import CookiePolicy from "./LandingPage/CookiePolicy";
import OtherData from './Context/OtherData';
import FAQs from './LandingPage/FAQs';
import DetailCloseContract from './DetailPO/DetailCloseContract';
import BlogList from './Blogs/BlogList';
import Blog1 from './Blogs/Blog1';
import Blog2 from './Blogs/Blog2';
const NewLayout = () => {
    const [loggedInUserName, setLoggedInUsername] = useState();
    const [pageTitle,setPageTitle]=useState("");
    useEffect(() => {
        checkConnection().then(rr => rr.text()).then(res => console.log(res)).catch(err => console.log(err));
        //setHideSignUp(0);
    }, []);
    //const unlockPurchaseOrder = () => {
    //    if (PurchaseOrder.getPoId() > 0) {
    //        getRequest('api/POManagement/UnlockPO?poId=' + PurchaseOrder.getPoId(), UserProfile.getToken()).then(r => r.json()).then(res => {
    //            if (res) {
    //                console.log("Unlock done successfully.");
    //            }

    //        }).catch(err => {
    //            console.log(err);
    //        });
    //    }
    //};
    return (
        <div >
            {loggedInUserName && loggedInUserName.length > 0 ? <>
                
                <aside className="sidebar">
                    <div className="sidebar-header">
                        <div className="logo">
                            <i className="fas fa-file-contract" style={{ color: '#0F172A' }}></i>
                            <a style={{ textDecoration: "none" }} href="/" onClick={(e) => {
                                OtherData.resetData();
                            }}>
                                <span style={{ color: '#0F172A' }}>Contr
                                    <span style={{ color: "#ff8400" }}>e</span>
                                    ct</span>
                            </a>
                        </div>
                    </div>

                    <nav className="nav-menu scrollable-section">
                        <div className="nav-title">Dashboard</div>
                        <a href="/home" className="nav-item active">
                            <i className="fas fa-home"></i>
                            <span>Overview</span>
                        </a>
                        <a href="/AnalyticsPage" className="nav-item">
                            <i className="fas fa-chart-line"></i>
                            <span>Analytics</span>
                        </a>

                        <div className="nav-title">Contracts</div>
                        <a href="/AllContracts" className="nav-item">
                            <i className="fas fa-file-signature"></i>
                            <span>All Contracts</span>
                        </a>
                        <a href="/GeneratedByAI" className="nav-item">
                            <i className="fas fa-plus-circle"></i>
                            <span>Create New</span>
                        </a>
                        <div className="nav-title">Settings</div>
                        <a href="/" className="nav-item">
                            <i className="fas fa-cog"></i>
                            <span>Account Settings</span>
                        </a>
                    </nav>
                </aside>
                <div className="headerHome">
                    <div className="page-title">
                        <h1>{pageTitle}</h1>
                        <p>Welcome back, here's what's happening with your contracts today</p>
                    </div>
                    <div className="user-profile">
                        <div style={{width:'50px',height:'50px',borderRadius:"50px", marginRight:"20px", backgroundColor:"#0F172A",color:"white"}}>
                            <h3 style={{textAlign:'center',paddingTop:"8px"}}>{loggedInUserName.toString()[0]+loggedInUserName.toString()[1]}</h3>
                        </div>
                        <div className="user-info">
                            <h4>{loggedInUserName}</h4>
                            <a href="/LogOut" style={{ color: "#0F172A" }}>Logout</a>
                        </div>
                    </div>
                </div>
                </>:<></>}
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/Signup" element={<SignInPage />} />
                    <Route path="/Home" element={<HomePage setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/Terms" element={<TermsAndCondtitions setUserName={setLoggedInUsername} setPageTitle={setPageTitle} />} />
                    <Route path="/Policy" element={<PrivacyPolicy setUserName={setLoggedInUsername} setPageTitle={setPageTitle} />} />
                    <Route path="/AboutUs" element={<AboutUs setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                     <Route path="/FAQs" element={<FAQs setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/CookiePolicy" element={<CookiePolicy setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/ContactUs" element={<ContactUs setUserName={setLoggedInUsername} setPageTitle={setPageTitle} />} />
                    <Route path="/AllContracts" element={<ContractListPage setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/AnalyticsPage" element={<AnalyticsPage setUserName={setLoggedInUsername}  /> }/>
                    <Route path="/UpdateUser" element={<UpdateUser setUserName={setLoggedInUsername} />} />
                    <Route path="/LogOut" element={<LogOut setUserName={setLoggedInUsername} />} />
                    <Route path="/DraftInvoice" element={<DraftInvoice />} />
                    <Route path="/EditInvoice" element={<EditInvoice />} />
                    <Route path="/EditTxnNote" element={<EditTxnNote />} />
                    <Route path="/DetailContract" element={<DetailContract setUserName={setLoggedInUsername} setPageTitle={setPageTitle}/>} />
                    <Route path="/DraftCloseContract" element={<DetailCloseContract setUserName={setLoggedInUsername} setPageTitle={setPageTitle}/>} />
                    <Route path="/pay" element={<PaymentComponent setUserName={setLoggedInUsername} />} />
                    <Route path="/subscriptionList" element={<SubscriptionPage setUserName={setLoggedInUsername} setPageTitle={setPageTitle} />} />
                    <Route path="/GeneratedByAI" element={<AIGenerateContract setUserName={setLoggedInUsername} />} />
                    <Route path="/DraftContract" element={<DraftContract setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/BlogList" element={<BlogList setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/Blog1" element={<Blog1 setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path="/Blog2" element={<Blog2 setUserName={setLoggedInUsername} setPageTitle={setPageTitle}  />} />
                    <Route path='*' element={<WrongAddress />} />
                </Routes>
            </BrowserRouter>
            <footer>
                <div className="container">
                    <div className="footerContent" style={{width:  '100%',marginLeft:(loggedInUserName?100:0)}}>
                        <div className="footerColumn">
                            <h3>Contrect</h3>
                            <p>Smart contract management for modern businesses and professionals.</p>
                            <div className="social-links">
                                <a href="/" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                                <a href="/" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
                                <a href="/" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
                                <a href="/" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                            </div>
                        </div>
                        <div className="footerColumn">
                            <h3>Resources</h3>
                            <ul>
                                <li>
                                    <a href="/FAQs">Help Center</a>
                                </li>
                                <li><a href="/BlogList">Blog</a></li>
                                <li><a href="/subscriptionList">Subscription List</a></li>
                            </ul>
                        </div>
                        <div className="footerColumn">
                            <h3>Company</h3>
                            <ul>
                                <li><a href="/AboutUs">About Us</a></li>
                                <li><a href="/ContactUs">Contact</a></li>
                                <li><a href="/FAQs">FAQ</a></li>
                            </ul>
                            
                        </div>
                        <div className="footerColumn">
                            <h3>Legal</h3>
                            <ul>
                                <li><a href="/Policy">Privacy Policy</a></li>
                                <li><a href="/Terms">Terms of Service</a></li>
                                <li><a href="/CookiePolicy">Cookie Policy</a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>&copy; 2025 Musedaq Fintech Private Limited. All rights reserved. 4 May 2025 11:21 PM</p>
                    </div>
                </div>
            </footer>

        </div>
    );
}
export default NewLayout;